import { AutogenModelBrltlSpotQuote, AutogenRowBrltlSpotQuote } from "./autogen/AutogenModelBrltlSpotQuote";

export class ModelBrltlSpotQuote extends AutogenModelBrltlSpotQuote<RowBrltlSpotQuote> {
    constructor() {
        super(RowBrltlSpotQuote);
    }
}

export class RowBrltlSpotQuote extends AutogenRowBrltlSpotQuote {
}